import { QuestionV3ControlTypes } from './enum';
import { QuestionBaseV3 } from './question-base';

export class PhotoQuestionV3 extends QuestionBaseV3 {
  controlType = QuestionV3ControlTypes.PHOTO;
  src: string | ArrayBuffer;
  useLibrary: boolean;
  maxSize?: number;
  allowedExtension?: string[];

  constructor(options: any = {}) {
    super(options);
    this.src = options['src'] || '';
    this.useLibrary = options['useLibrary'] || true;
    this.maxSize = options['maxSize'] || 10;
    this.allowedExtension = options['allowedExtension'] || [
      'image/jpg',
      'image/png',
      'image/jpeg'
    ];
  }
}
